import { IWorkOrder } from '../common/data/dtos/work-order';
import { IWorkOrderByCollectionId } from '../common/data/dtos/work-order-by-collection-id';
import { DELETE_TYPED_ASYNC, GET_TYPED_ASYNC, POST_TYPED_ASYNC, PUT_TYPED_ASYNC } from '../helpers/httpHelper';

const BASE_PATH = 'api/WorkOrder';

interface WorkOrderResponse {
    success: boolean;
    workOrder?: IWorkOrder;
    workOrders?: IWorkOrder[];
    error?: string;
}

interface WorkOrderDetailResponse {
    success: boolean;
    workOrders?: IWorkOrderByCollectionId[];
    error?: string;
}

const getWorkOrders = async (): Promise<WorkOrderResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<IWorkOrder>(`${BASE_PATH}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, workOrders: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getWorkOrderGetByCollectionId = async (ids: string[]): Promise<WorkOrderDetailResponse> => {
        try {
        const response = await POST_TYPED_ASYNC<IWorkOrderByCollectionId>(`${BASE_PATH}/GetByCollectionId`, ids);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, workOrders: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const updateWorkOrder = async (workOrder: IWorkOrder): Promise<WorkOrderResponse> => {
    try {
        const response = await PUT_TYPED_ASYNC<IWorkOrder>(`${BASE_PATH}/${workOrder.id}`, workOrder);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const deleteWorkOrder = async (id: string): Promise<WorkOrderResponse> => {
    try {
        const response = await DELETE_TYPED_ASYNC<IWorkOrder>(`${BASE_PATH}/${id}`);

        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

export default {
    getWorkOrders,
    getWorkOrderGetByCollectionId,
    updateWorkOrder,
    deleteWorkOrder
};
